/**
 * Which in-flight request is still allowed to write to shared state.
 *
 * `useApi` used to let EVERY request commit whenever it happened to resolve, so
 * a slow request outlived the navigation that replaced it: request `ZZSLOW`,
 * move to `ZZGOOD`, and `ZZSLOW`'s late response overwrote `ZZGOOD`'s data with
 * the wrong symbol's numbers — financial data sitting under the wrong ticker's
 * header until some later poll happened to succeed.
 *
 * A monotonic generation rather than an abort, deliberately. Aborting is racy in
 * the same way: a response that has already resolved cannot be un-committed, so
 * abort reduces wasted work but cannot make the guarantee. This can.
 *
 * Extracted from the hook so the rule is testable on its own — the repository
 * has no React test renderer, and "obviously correct" is precisely the claim
 * this whole review round has been rejecting.
 */
export interface RequestGate {
  /**
   * Start a request and supersede every earlier one. Returns a predicate that is
   * true only while this request is still the newest.
   */
  claim: () => () => boolean;
}

export function createRequestGate(): RequestGate {
  let current = 0;
  return {
    claim: () => {
      const generation = (current += 1);
      return () => generation === current;
    },
  };
}
